import { Separator } from '@plato/ui/primitives/separator';
import { type ReactElement, Fragment } from 'react';
import type { ActivityFeedVisitPayload } from '../../../server/types/customer-activity-feed-types.ts';
import type { TaskCompletedSource } from '../../analytics/types/analytics-events.ts';
import { orderVisitLogged } from '../lib/order-visit-logged.ts';
import { ActivityFeedNoteItem } from './activity-feed-note-item.tsx';
import { VisitLoggedItem } from './visit-logged-item.tsx';

type Props = {
    payload: ActivityFeedVisitPayload;
    source: TaskCompletedSource;
};

/**
 * A logged visit as rows of a customer box: its report, then what was logged on it —
 * each linked quote with its tasks, the other tasks, then the insight outcomes —
 * indented onto the report's text edge so the stack still reads as one visit.
 */
export function GlobalActivityFeedVisitItem({ payload, source }: Props): ReactElement {
    const { tasks, outcomes, quotes, ...note } = payload;
    const logged = orderVisitLogged(payload);

    return (
        <>
            <ActivityFeedNoteItem note={note} />
            {logged.length > 0 && (
                // ml-6: the report's 16px icon plus the row's 8px gap
                <div className="ml-6 flex flex-col">
                    {logged.map((entry) => (
                        <Fragment key={entry.key}>
                            <Separator />
                            <VisitLoggedItem entry={entry} source={source} />
                        </Fragment>
                    ))}
                </div>
            )}
        </>
    );
}
